const settingsProd = {
  BASE_API_URL: "https://api.vaix.ai/",
  API_TOKEN: "d9184ea447f53423fbed041144988ad334e4f3197fa01846bb727f46b1973f51",
  DEFAULT_USER_ID: "0",
};

export default settingsProd;
